import { Anchor, Code, Table, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

import { useProfiles } from '../api/hooks';
import { DataState } from '../components/DataState';
import { PageHeader } from '../components/PageHeader';
import { fmtRelative } from '../theme/format';

export function ProfilesPage() {
  const { data, isLoading, error } = useProfiles();

  return (
    <>
      <PageHeader
        title="Profiles"
        description="The people this project can reach. Created by your SDKs through POST /v1/profiles."
      />

      <DataState
        loading={isLoading}
        error={error}
        empty={!data?.data.length}
        emptyTitle="No profiles yet"
        emptyDescription="Call POST /v1/profiles with a public key to identify a user."
      >
        <Table.ScrollContainer minWidth={720}>
          <Table>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>External ID</Table.Th>
                <Table.Th>Email</Table.Th>
                <Table.Th>Phone</Table.Th>
                <Table.Th>Traits</Table.Th>
                <Table.Th>Last seen</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {data?.data.map((p) => (
                <Table.Tr key={p.id}>
                  <Table.Td>
                    <Anchor component={Link} to={`/profiles/${p.id}`} size="sm" fw={500}>
                      {p.external_id ?? p.id.slice(0, 8)}
                    </Anchor>
                  </Table.Td>
                  <Table.Td><Text size="sm">{p.email ?? '—'}</Text></Table.Td>
                  <Table.Td><Text size="sm">{p.phone ?? '—'}</Text></Table.Td>
                  <Table.Td maw={280}>
                    <Code style={{ fontSize: 11 }}>
                      {JSON.stringify(p.traits).slice(0, 60)}
                    </Code>
                  </Table.Td>
                  <Table.Td>
                    <Text size="xs" c="dimmed">{fmtRelative(p.last_seen_at)}</Text>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </DataState>
    </>
  );
}
